import { REACT_APP_IFRAMELY_API_KEY } from '../../../../env'

export interface IframelyData {
  meta: {
    title: string
    medium?: string
  }
  links: {
    icon: { href: string }[]
  }
}

export interface IframelyError {
  error: string
  status: number
}

export async function getURLMetadata(url: string): Promise<IframelyData | IframelyError> {
  const response = await fetch(`https://iframe.ly/api/iframely?key=${REACT_APP_IFRAMELY_API_KEY}&url=${url}`)
  return response.json()
}
